export const CONTENT_DEFAULT_SIZE = 's';

export const CONTENT_DEFAULT_COL_SIZES = {all: 12, md: 12};

export const CONTENT_DEFAULT_THEME = 'default';

export const DEFAULT_PAGE = 1;

export const DEFAULT_ROWS_PER_PAGE = 12;
